import React from "react";
import LayoutSection from "../../layouts/layoutSection";
import TitreText from "../ui/typographic/titreText";
import Legend from "../ui/typographic/legend";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

const NapsisTeamPhoto = ({ lineStep, content }) => {
  const { ref: divdRef, inView: divIsVisible } = useInView({
    threshold: .2,
  });
  console.log(divIsVisible)
  return (
    <LayoutSection
      lineStep={lineStep}
      full
    >
      <div className=" md:flex md:justify-center md:items-center md:gap-8 md:h-screen noir-bckd">
        <div className="container mx-auto flex justify-center items-center flex-col gap-4 md:flex-1 md:pl-[10%]">
          <div className="basis-1/3">
          <Legend
              content={content.soustitre}
              inView={divIsVisible}
              reference={divdRef}
            />
            <TitreText
              Legende={content.soustitre}
              Titre={content.titre}
              Text={content.description}
              Color='white'
              inView={divIsVisible}
              reference={divdRef}
            />
          </div>
        </div>
        <div className="pb-2 hidden md:block md:pb-0 md:basis-1/2 relative overflow-hidden h-full">
          <StaticImage
            className=" absolute  h-full"
            src="../../../images/napsis-team.jpg"
            alt="Equipe Napsis"
          />
        </div>
      </div>
    </LayoutSection>
  )
}


export default NapsisTeamPhoto
